import React, { useCallback } from 'react';

const RoleDisplayFormatter = (props) => {
   const getRoleDisplay = useCallback(() => {
      let role = 'Organization Full Access';
      let userRoles = props.roles ? props.roles : [];
      if (userRoles.includes('ROLE_ADMIN')) {
         role = 'Super Admin';
      } else if (userRoles.includes('ROLE_USER')) {
         role = 'Organization Full Access';
      } else if (userRoles.includes('ROLE_COMP_ADMIN')) {
         role = 'Hiring Company Full Access';
      } else if (userRoles.includes('ROLE_COMP_ACCT')) {
         role = 'Hiring Company Restricted';
      }
      return role;
   }, [props.roles]);

   return (
      <>
         {getRoleDisplay()}
      </>
   );
};

export default RoleDisplayFormatter;
